





























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { formatCurrency } from "@/shared/currency";
import { InstrumentDetail } from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {}
})
export default class SharePriceTable extends Vue {
  @Prop({ required: true }) amountUsd: number;
  @Prop({ required: true }) symbol: string;

  drivewealthStore = useDrivewealthStore();

  formatCurrency = formatCurrency;
  $validator: Validator;

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.cachedInstrumentDetailBySymbol(this.symbol);
  }

  get numShares () {
    if (!this.instrumentDetail ||
        this.instrumentDetail.currentPrice === undefined ||
        this.instrumentDetail.currentPrice === null ||
        this.instrumentDetail.currentPrice === 0) {
      return "0";
    }
    return (this.amountUsd / this.instrumentDetail.currentPrice).toFixed(6);
  }
}
